import {
  USERLIST_SUCCESS,
  USERVENDORLIST_SUCCESS,
  IS_LOADING,
  USER_DETAIL_SUCCESS,
  USERLIST_DETAIL_SUCCESS,
  BANK_VERIFICATION_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  PROFILE_UPDATE_SUCCESS,
  PROFILE_UPDATE_ERROR,
  THEME_UPDATE_SUCCESS,
  THEME_UPDATE_ERROR,
  VENDOR_THEME_CUSTOMIZATION,
  VENDOR_THEME_ERROR,
  VENDOR_CREATE_SUCCESS,
  USER_BALANCE_API_SUCCESS,
  USER_BALANCE_API_ERROR,
  JOIN_API_SUCCESS,
  JOIN_API_ERROR,
  DEPOSIT_API_SUCCESS,
  DEPOSIT_API_ERROR,
} from "../actions/Type";

const initialState = {
  uservendor_list: {},
  user_list: {},
  user_detail: [],
  user_list_detail: {},
  user_verification: {},
  loading: false,
  bank_verify: {},
  change_password: {},
  error: {},
  profile_update: {},
  theme_update: {},
  customization_Deatils: {},
  theme_update_refresh: false,
  update_vendor: true,
  create_vendor_details: {},
  update_vendor_list: false,
  // api checking
  game_api_success_list: {},
  update_game_api_success: false,
  deposit_api_success_list: {},
  update_deposit_api_success: false,
  balance_api_success_list: {},
  update_balance_api_success: false,
};

const UsersReducers = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case IS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case USERVENDORLIST_SUCCESS:
      return {
        ...state,
        uservendor_list: payload,
        loading: false,
      };
    case USERLIST_SUCCESS:
      return {
        ...state,
        user_list: payload,
        loading: false,
      };
    case USER_DETAIL_SUCCESS:
      return {
        ...state,
        user_detail: payload,
        loading: false,
      };

    case USERLIST_DETAIL_SUCCESS:
      return {
        ...state,
        user_list_detail: payload,
        loading: false,
      };
    case BANK_VERIFICATION_SUCCESS:
      return {
        ...state,
        bank_verify: payload,
        loading: false,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        change_password: payload,
        loading: false,
      };
    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        change_password: payload.response,
        loading: false,
      };
    case PROFILE_UPDATE_SUCCESS:
      return {
        ...state,
        profile_update: payload,
        loading: false,
      };
    case PROFILE_UPDATE_ERROR:
      return {
        ...state,
        profile_update: payload.response,
        loading: false,
      };
    case THEME_UPDATE_SUCCESS:
      return {
        ...state,
        theme_update: payload,
        loading: false,
        theme_update_refresh: true,
      };
    case THEME_UPDATE_ERROR:
      return {
        ...state,
        theme_update: payload.response,
        loading: false,
      };
    case VENDOR_THEME_CUSTOMIZATION:
      return {
        ...state,
        customization_Deatils: payload,
        loading: false,
      };
    case VENDOR_THEME_ERROR:
      return {
        ...state,
        customization_Deatils: payload.response,
        loading: false,
      };
    case VENDOR_CREATE_SUCCESS:
      return {
        ...state,
        create_vendor_details: payload,
        update_vendor_list: true,
        loading: false,
      };
    case USER_BALANCE_API_SUCCESS:
      return {
        ...state,
        balance_api_success_list: payload,
        update_balance_api_success: true,
        loading: false,
      };
    case USER_BALANCE_API_ERROR:
      return {
        ...state,
        balance_api_success_list: payload,
        // update_balance_api_success: true,
        // loading: false,
      };
    case JOIN_API_SUCCESS:
      return {
        ...state,
        game_api_success_list: payload,
        update_game_api_success: true,
        loading: false,
      };
    case JOIN_API_ERROR:
      return {
        ...state,
        game_api_success_list: payload,
        //update_game_api_success: true,
        loading: false,
      };
    case DEPOSIT_API_SUCCESS:
      return {
        ...state,
        deposit_api_success_list: payload,
        update_deposit_api_success: true,
        loading: false,
      };
    case DEPOSIT_API_ERROR:
      return {
        ...state,
        deposit_api_success_list: payload,
        //update_game_api_success: true,
        loading: false,
      };

    default:
      return state;
  }
};

export default UsersReducers;
